import { render, staticRenderFns } from "./HtmlSplitEditor.vue?vue&type=template&id=13c47c8e&scoped=true&"
import script from "./HtmlSplitEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlSplitEditor.vue?vue&type=script&lang=js&"
import style0 from "./HtmlSplitEditor.vue?vue&type=style&index=0&id=13c47c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c47c8e",
  null
  
)

export default component.exports